import React from "react"
import { css } from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import Block from "../../atoms/layout-primitives/block"
import { Alignments } from "../../molecules/icon-title"
import {
  ContentfulIconTitleCard,
  IContentfulIconTitleCard,
} from "../../molecules/icon-title-card"
import { T } from "../../styles/typography"

const FeatureGridCol = ({
  features,
}: {
  features: IContentfulIconTitleCard[]
}) => {
  return (
    <Block
      display={{ sm: "grid" }}
      variants={[
        css`
          grid-template-columns: 1fr;
          grid-column: 1 / -1;
          grid-row-gap: 32px;
          width: 100%;
        `,
        css`
          grid-column: 2 / -2;
          grid-row-gap: 48px;
        `,
        css`
          grid-template-columns: 1fr 1fr;
          grid-row-gap: 64px;
          grid-column-gap: 96px;
          @media (min-width: ${Breakpoints.xl}) {
            grid-column: 3 / -3;
          }
        `,
      ]}
    >
      {features.map((feature, index) => (
        <ContentfulIconTitleCard
          key={index}
          titleTag="h3"
          titleAlignmentVariants={[
            Alignments["column-centered"],
            Alignments["flex-row-center"],
            Alignments["row-left"],
          ]}
          titleVariants={{
            sm: css`
              margin-top: 24px;
              ${T.sm.h3(500)}
            `,
            md: css`
              margin-top: 0px;
              ${T.md.h4(500)}
            `,
            lg: css`
              ${T.lg.h4(400)}
              line-height: 120%;
            `,
          }}
          iconVariants={{
            sm: { width: "40px", height: "40px" },
            lg: { width: "48px", height: "48px" },
          }}
          bodyVariants={[
            css`
              text-align: center;
              margin-top: 16px;
            `,
            null,
            css`
              text-align: left;
            `,
          ]}
          {...feature}
        />
      ))}
    </Block>
  )
}

export default FeatureGridCol
